import { ThreadNav } from "@/components/thread-nav/ThreadNav";
import { makeStyles, tokens } from "@fluentui/react-components";
import React from "react";
import { Outlet } from "react-router-dom";

export const DefaultLayout: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <nav className={classes.nav}>
        <ThreadNav />
      </nav>
      <main className={classes.main}>
        <Outlet />
      </main>
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "stretch",
    height: "100vh",
    overflow: "hidden",
  },
  nav: {
    width: "253px",
    height: "100%",
    borderRight: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  main: {
    flex: 1,
    background: "#908080",
    height: "100%",
  },
});
